/** @file Keeps a skinned mesh's bindPose equal to its weighted bones (new bones bind at their setup world). */
import type { Id, MeshAtt } from '@pose2d/format/types';
import { bindMatrix } from './bindMatrix';
import { weightedBones } from './weightedBones';

type Skinned = Extract<MeshAtt['geometry'], { kind: 'skinned' }>;

/** Rebuilds `g.bindPose` in bone-id order: entries of still-weighted bones kept, new bones bound now, the rest dropped. */
export function syncBindPose(g: Skinned, worldOf: (bone: Id) => Float64Array): void {
  const next: Record<Id, number[]> = {};
  for (const bone of weightedBones(g.weights)) {
    const kept = g.bindPose[bone];
    next[bone] = kept ? [...kept] : bindMatrix(worldOf, bone, 'weights');
  }
  g.bindPose = next;
}
